export default "__VITE_ASSET__DSKiSuvo__"